import FormatListBulletedAddIcon from "@mui/icons-material/FormatListBulleted";
import AutoAwesomeIcon from "@mui/icons-material/AutoAwesome";
import AssistantIcon from "@mui/icons-material/Assistant";
import ContentPasteIcon from "@mui/icons-material/ContentPaste";
import NewspaperIcon from "@mui/icons-material/Newspaper";
import BoltIcon from "@mui/icons-material/Bolt";
import ElectricBoltIcon from "@mui/icons-material/ElectricBolt";
import AttachMoneyIcon from "@mui/icons-material/AttachMoney";
import NotesIcon from "@mui/icons-material/Notes";
import ExploreIcon from "@mui/icons-material/Explore";
import VideoCallIcon from "@mui/icons-material/VideoCall";
import GroupIcon from "@mui/icons-material/Group";
import FolderIcon from "@mui/icons-material/Folder";
import PhoneAndroidIcon from "@mui/icons-material/PhoneAndroid";
import TuneIcon from "@mui/icons-material/Tune";
import GroupsIcon from "@mui/icons-material/Groups";
import PublicIcon from "@mui/icons-material/Public";
import PictureAsPdfIcon from "@mui/icons-material/PictureAsPdf";

const style = { margin: "0px" };

export const IconEnumDisplay = (name: string): JSX.Element | null => {
  switch (name) {
    case "icon-coin-dollar":
      return <AttachMoneyIcon fontSize="large" style={style} />;
    case "icon-notes":
      return <NotesIcon fontSize="large" style={style} />;
    case "icon-discovery":
      return <ExploreIcon fontSize="large" style={style} />;
    case "icon-skype":
      return <VideoCallIcon fontSize="large" style={style} />;
    case "icon-electricity":
      return <ElectricBoltIcon fontSize="large" style={style} />;
    case "icon-bolt":
      return <BoltIcon fontSize="large" style={style} />;
    case "icon-users":
      return <GroupIcon fontSize="large" style={style} />;
    case "icon-folder":
      return <FolderIcon fontSize="large" style={style} />;
    case "icon-mobile":
      return <PhoneAndroidIcon fontSize="large" style={style} />;
    case "icon-knob":
      return <TuneIcon fontSize="large" style={style} />;
    case "icon-list":
      return <ContentPasteIcon fontSize="large" style={style} />;
    case "icon-team":
      return <GroupsIcon fontSize="large" style={style} />;
    case "icon-earth":
      return <PublicIcon fontSize="large" style={style} />;
    case "icon-file-pdf":
      return <PictureAsPdfIcon fontSize="large" style={style} />;
    case "icon-news":
      return <NewspaperIcon fontSize="large" style={style} />;
    case "icon-library":
      return <i className="icon icon-library" />;
    case "auto-awesome":
      return <AutoAwesomeIcon fontSize="large" style={style} />;
    case "list-add":
      return <FormatListBulletedAddIcon fontSize="large" style={style} />;
    case "assistant":
      return <AssistantIcon fontSize="large" style={style} />;

    default:
      return null;
  }
};
